import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {IToken} from './interfaces/token.interface';
import { CryptoStorageService } from '@services/storage-service.service';

@Injectable({providedIn: 'root'})
export class TokenService {
  token: BehaviorSubject<IToken> = new BehaviorSubject<IToken>(null);

  constructor(
    private cryptoStorageService: CryptoStorageService,

  ) {
    const sessionStorageToken = this.cryptoStorageService.getFromSessionStorage('T');
    if (sessionStorageToken) {
      this.token.next(sessionStorageToken);
    }
  }

  getToken(): Observable<IToken> {
    return this.token.asObservable();
  }

  parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  validateToken(token: IToken, idn: string): boolean  {
    const parsedToken = this.parseJwt(token.access_token);
    return parsedToken?.provider_response?.user_info?.organization?.idn === idn;
  }

  setToken(token): void {
    if (token?.access_token || token?.refresh_token) {
      this.cryptoStorageService.addJWTInfoForAkKamalClients(token);
      this.cryptoStorageService.setToSessionStorage('T', token);
      this.token.next(token);
    }
  }
}
